import React from "react";
import { useTranslation } from "react-i18next";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alert-dialog";

const CycleDeleteDialog = ({ open, onOpenChange, selectedPattern, handleDeletePattern }) => {
  const { t } = useTranslation();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("planning.cycles.deleteTitle")}</AlertDialogTitle>
          <AlertDialogDescription>
            {t("planning.cycles.deleteDescription", { name: selectedPattern?.name })}
          </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>{t("planning.scheduleManager.actions.cancel")}</AlertDialogCancel>
        <AlertDialogAction onClick={handleDeletePattern} className="bg-red-500 hover:bg-red-600">
          {t("planning.scheduleManager.actions.delete")}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
  );
};

export default CycleDeleteDialog;
